import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    isReorderConfirmationModalOpen: boolean;
}>;

export const DispatchSetIsReorderConfirmationModalOpen: HandlerType = props => {
    props.dispatch({
        type: "Pages/VmiBins/SetIsReorderConfirmationModalOpen",
        isReorderConfirmationModalOpen: props.parameter.isReorderConfirmationModalOpen,
    });
};

export const chain = [DispatchSetIsReorderConfirmationModalOpen];

const setIsReorderConfirmationModalOpen = createHandlerChainRunner(chain, "SetIsReorderConfirmationModalOpen");
export default setIsReorderConfirmationModalOpen;
